// Module
var code = `<i class="fa fa-info-circle text-info" uib-tooltip="{{ tooltipController.message }}" tooltip-append-to-body="true" tooltip-placement="auto"></i> `;
// Exports
module.exports = code;